export const tabOptions = ['definition', 'facts', 'implementation'] as const
export type TabOption = (typeof tabOptions)[number]
